const getStudentsListData = state => state?.driveInfo?.studentDriveList
const getViewDriveInfoData = state => state?.driveInfo?.studentViewDriveInfo
const getSingleStudentData = state => state?.institute?.singleStudentData
const selectors = {
  getStudentsListData,
  getViewDriveInfoData,
  getSingleStudentData,
}
export default selectors
